import { createSlice } from '@reduxjs/toolkit';
import { fetchProvinces } from '../thunks';

interface ProvinceState {
  items: { id: string; name: string }[];
  count: number;
  pages: number;
  page: number;
  limit: number;
  loading: boolean;
  error: string | null;
}

const initialState: ProvinceState = {
  items: [],
  count: 0,
  pages: 0,
  page: 1,
  limit: 10,
  loading: false,
  error: null
};

const provinceSlice = createSlice({
  name: 'provinces',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProvinces.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProvinces.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchProvinces.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch provinces';
      });
  }
});

export const provinceReducer = provinceSlice.reducer;
